import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { repiActions } from '../../../store/repiStore';
import ModalInner from '../../layoutItems/modalInner';

import '../repi.scss';
import { isNullOrUndefined } from '../../../store/storeFunctions';

class RepiAddSubjectValidationErrorsPopup extends React.Component {
    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Repi.DataCorrection.AddSubject.Validation.Results")}>
                <div className="repi-modal-body">
                    {this.renderTable(this.props.data.errors, true, !isNullOrUndefined(this.props.data.warnings) && this.props.data.warnings.length > 0)}
                    {this.renderTable(this.props.data.warnings, false)}
                </div>
            </ModalInner>
        );
    }

    renderTable = (data, isErrorsTable, bottomMargin = false) => {
        if (isNullOrUndefined(data) || data.length === 0)
            return null;

        return (
            <div style={bottomMargin ? { marginBottom: "2.5em" } : undefined}>
                <div>
                    <h2 style={{ fontWeight: "bold" }}>
                        <Translate id={`Repi.DataCorrection.Email.${(isErrorsTable ? "Errors" : "Warnings")}`} />
                    </h2>
                </div>
                <table className="repi-data-correction-table fixed">
                    <thead>
                        <tr>
                            <th className="p5"><Translate id="Repi.DataCorrection.ValidationError.Code" /></th>
                            <th className="p5"><Translate id="Repi.DataCorrection.ValidationError.Description" /></th>
                            <th className="p5"><Translate id="Repi.DataCorrection.ValidationError.Detail" /></th>
                            <th className="p5"><Translate id="Repi.DataCorrection.ValidationError.IsCritical" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(x => <tr className="repi-data-correction-table-row">
                            <td>{x.code}</td>
                            <td>{x.description}</td>
                            <td>{x.detail}</td>
                            <td>{this.props.translate(x.isCritical ? "Common.Yes" : "Common.No")}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default connect(
    null,
    dispatch => bindActionCreators(repiActions, dispatch),
)(withLocalize(RepiAddSubjectValidationErrorsPopup));
